import moment from "moment";
import React from "react";

import { useLocalStorage } from "../../../hooks";
import { userState } from "../../../redux/reducers/userReducer";

import profile_img from "../../../assets/avatar_placeholder.svg";

import { FunnelIcon } from "@heroicons/react/20/solid";
import { ArrowPathIcon } from "@heroicons/react/24/outline";
import { useDispatch, useSelector } from "react-redux";
import { useLocation } from "react-router-dom";
import calender_black from "../../../assets/calender_black.svg";
import { TwButton, TwListBox } from "../../../components/tailwind";
import { classNames, cutString } from "../../../helpers";
import { loadingState } from "../../../redux/reducers/loadingReducer";
import axiosInstance from "../../../utils/axiosInstance";
import { getUrlForBookings } from "../../../utils/confighelpers";
import { bookingStatusFilter } from "../../../utils/constants";
import SessionBookingPopover from "./SessionBookingPopover";


export default function RecentClassBooking({
    title = "Recent Bookings",
    bookingType = "teacherRecentBookings",
    customerId,
}) {
    const location = useLocation();
    const dispatch = useDispatch();
    const loadingReduxState = useSelector(loadingState);
    const [userToken] = useLocalStorage("userToken");
    const userReduxState = useSelector(userState);
    const [bookingInfo, setBookingInfo] = React.useState();
    // const [anchorEl, setAnchorEl] = React.useState(null);
    const [listLoading, setListLoading] = React.useState(false);

    const [recentBookingsList, setRecentBookingsList] = React.useState([]);
    const [showViewMore, setShowViewMore] = React.useState(false);
    const [recentBookingsPageNumber, setRecentBookingsPageNumber] = React.useState(1);
    const [bookingFilter, setBookingFilter] = React.useState('all');

    const getRecentBookings = async (page = 1) => {
        setShowViewMore(false);
        setListLoading(true);
        const manageClassesConfig = {
            method: "get",
            // url: `${getUrlForBookings()}getMybookings?teacherId=${userReduxState.userData?._id}${bookingType === "consumerBookings" ? `&studentId=${customerId}` : ``}&page=${page}&limit=5&filterBy=${bookingFilter}&listFor=${userReduxState.businessType}`,
            url: `${getUrlForBookings()}getMybookings?teacherId=${userReduxState.userData?.userType == "student" && userReduxState.userData?.myClubs.length > 0 && userReduxState.userData?.myClubs[0] ? userReduxState.userData?.myClubs[0].businessId : userReduxState.userData?._id}${userReduxState.userData?.userType == "student" || bookingType === "consumerBookings" ? `&studentId=${customerId}` : ``}&page=${page}&limit=5&filterBy=${bookingFilter}&listFor=${userReduxState.businessType}`,
        };
        const manageClassesRequest = await axiosInstance(manageClassesConfig);
        if (manageClassesRequest.status === 200) {
            if (manageClassesRequest.data?.data?.data.length) {
                if (manageClassesRequest.data.data.total > 10) {
                    setShowViewMore(true);
                }
                if (recentBookingsPageNumber > 1) {
                    setRecentBookingsList([...recentBookingsList, ...manageClassesRequest.data.data.data]);
                } else {
                    setRecentBookingsList(manageClassesRequest.data.data.data);
                }
            }
        }
        setListLoading(false);
    };

    const handleFilterChange = (event) => {
        const { target: { value } } = event;
        setRecentBookingsPageNumber(1)
        setBookingFilter(value);
        setRecentBookingsList([])
    };

    const calculateBoughtTickets = (row) => {
        let totalBookedTickets = 0;

        if (row && row?.ticketsBought?.length) {
            row?.ticketsBought.forEach((item) => {
                totalBookedTickets = totalBookedTickets + parseInt(item.bookingQty)
            })
        }

        return totalBookedTickets
    }

    const ticketAmount = (row) => {
        let amountPaid = "";

        if (row && row?.paymentMethod === "classPass" && row?.passVoucherCode) {
            amountPaid = `${calculateBoughtTickets(row)} Credit`
        } else if (row && row?.ticketsBought?.length) {
            row?.ticketsBought.forEach((item) => {
                amountPaid = `€${parseFloat(parseFloat(item?.ticketAmount ? item?.ticketAmount : 0)).toFixed(2)} `
            })
        }

        return amountPaid
    }

    const getPaymentStatus = (row) => {
        let paymentStatus = row.paymentStatus;
        if (row && row.paymentStatus.toLowerCase() === "paid" && row?.paymentMethod === "classPass" && row?.passVoucherCode) {
            paymentStatus = cutString(row?.purchase_voucher_detail?.selectedPassDetail?.passName || "", 20, true)
        } else if (row && row.paymentStatus.toLowerCase() === "paid") {
            paymentStatus = `Paid Online`
        }

        return paymentStatus
    }

    React.useEffect(() => {
        getRecentBookings(recentBookingsPageNumber);
    }, [recentBookingsPageNumber, bookingFilter]);

    return (
        <div
            className={`max-w-7xl px-5 py-2 bg-white rounded-lg border-0 border-bright-gray hover:border-indigo-bz ${bookingType === "teacherRecentBookings" ? "min-h-[500px] mt-16 pb-10" : ""}`}
        >
            <div className={"flex flex-row justify-between items-center [my-4] hidden"}>
                <div className={"flex flex-col"} style={{ flex: 1 }}>
                    <div className="flex justify-between">
                        <h3 className={"text-black text-lg"} >
                            {title}
                        </h3>
                        <div className="flex gap-2 justify-end items-center mb-10">
                            <TwButton variant={"default"} onClick={() => {
                                setRecentBookingsPageNumber(1);
                            }}>
                                <ArrowPathIcon aria-hidden="true" className="size-5 text-brown-coffee forced-colors:text-[Highlight]" />
                            </TwButton>
                            <TwListBox
                                value={bookingFilter}
                                options={bookingStatusFilter}
                                dropdownArrow={(<FunnelIcon aria-hidden="true" className="size-5 text-brown-coffee forced-colors:text-[Highlight]" />)}
                                onChange={(v) => {
                                    handleFilterChange({ target: { value: v.value } })
                                }}
                            />
                        </div>
                    </div>
                </div>
            </div>

            <div className={"flex flex-col gap-3 border-2 p-5 border-bright-gray rounded-lg"}>
                <div className="flex gap-2">
                    <div className="flex-1 flex items-center gap-2">
                        <img className={"size-5"} src={calender_black} alt={""} />
                        <h4 className="text-base font-semibold">{title}</h4>
                        <span className="text-sm text-muted-foreground">({recentBookingsList.length})</span>
                    </div>
                    <TwButton variant={"default"} onClick={() => {
                        setRecentBookingsPageNumber(1);
                    }}>
                        <ArrowPathIcon aria-hidden="true" className="size-5 text-brown-coffee forced-colors:text-[Highlight]" />
                    </TwButton>
                    <TwListBox
                        value={bookingFilter}
                        options={bookingStatusFilter}
                        dropdownArrow={(<FunnelIcon aria-hidden="true" className="size-5 text-brown-coffee forced-colors:text-[Highlight]" />)}
                        onChange={(v) => {
                            handleFilterChange({ target: { value: v.value } })
                        }}
                    />
                </div>
                <div className="overflow-x-auto">
                    <div className="inline-block min-w-full py-2 align-middle sm:px-1">
                        <div className="overflow-hidden [shadow] ring-0 ring-black/5 sm:rounded-lg">
                            <table className="min-w-full divide-y divide-gray-300">
                                <thead className="bg-gray-50">
                                    <tr>
                                        <th scope="col" className={classNames("py-3.5 pl-4 pr-3 text-left text-sm font-extrabold text-gray-500 sm:pl-6 truncate", bookingType === "consumerBookings" ? "hidden" : "")}>
                                            Customer
                                        </th>
                                        <th scope="col" className="py-3.5 pl-4 pr-3 text-left text-sm font-extrabold text-gray-500 sm:pl-10 min-w-52">
                                            Booking Id
                                        </th>
                                        <th scope="col" className="px-3 py-3.5 text-left text-sm font-extrabold text-gray-500">
                                            Activity Booked
                                        </th>
                                        {/* <th scope="col" className="px-3 py-3.5 text-left text-sm font-semibold text-gray-700">
                                            Seats Booked
                                        </th> */}
                                        <th scope="col" className="px-3 py-3.5 text-left text-sm font-extrabold text-gray-500">
                                            Amount Paid
                                        </th>
                                        <th scope="col" className="px-3 py-3.5 text-left text-sm font-extrabold text-gray-500">
                                            Action
                                        </th>
                                        {/* <th scope="col" className="relative py-3.5 pl-3 pr-4 sm:pr-6">
                                                        <span className="sr-only">Action</span>
                                                    </th> */}
                                    </tr>
                                </thead>
                                <tbody className="divide-y divide-gray-200 bg-white">
                                    {(recentBookingsList.length > 0 ? recentBookingsList.map((row) => {

                                        return (
                                            <tr key={row._id} className="hover:bg-gray-50 transition-colors">
                                                <td className={classNames("whitespace-nowrap py-4 pl-4 pr-3 text-sm font-medium text-gray-900 [sm:pl-6] capitalize", bookingType === "consumerBookings" ? "hidden" : "")}>
                                                    <div className="flex justify-start items-center min-w-4/5">
                                                        <div className="flex-none">
                                                            {row?.student_detail?.profilePic ? (<img
                                                                className="size-8 rounded-full mr-3"
                                                                src={row.student_detail.profilePic}
                                                                alt={``}
                                                            />) : (<img
                                                                className="size-8 rounded-full mr-3"
                                                                src={profile_img}
                                                                alt={``}
                                                            />)}
                                                        </div>
                                                        <div className="[w-28]">
                                                            {/* <div>{cutString(row?.student_detail?.fullName, 10, true)}</div> */}
                                                            {/* <div className="text-indigo-bz">{cutString((row.student_detail?.countryCode ? row.student_detail.countryCode + "_" + row.student_detail.phoneNumber : "" + row?.student_detail?.username), 10, true)}</div> */}
                                                            <div className="line-clamp-1">{row?.student_detail?.fullName}</div>
                                                            <div className="text-indigo-bz line-clamp-1">{(row.student_detail?.countryCode ? row.student_detail.countryCode + "_" + row.student_detail.phoneNumber : "" + row?.student_detail?.username)}</div>
                                                        </div>
                                                    </div>
                                                </td>
                                                <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-500">
                                                    {row.bookingId}
                                                    <p className="text-xs text-gray-400 font-normal text-wrap"><span className={`${(row.status === "Cancelled") ? "text-bz-status-red" : "text-bz-status-green"}`}>{row.status}</span> | {moment(row.bookingDate).format("MMM D")}</p>
                                                </td>
                                                <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-500">
                                                    {row.className}
                                                    <p className="text-xs text-gray-400 font-normal text-wrap">{row.schedule_class_detail && row.schedule_class_detail.classDate ? moment(row.schedule_class_detail.classDate).format('MMM D, hh:mm A') : ""}</p>
                                                </td>
                                                {/* <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-500">
                                                    {row.bookingQty ? row.bookingQty : "1"}
                                                    <p className="text-xs text-gray-400 font-normal text-wrap" title={row?.ticketsBought ? row.ticketsBought.map((ticket, i) => {
                                                        return ticket.bookingQty + " x " + ticket.ticketType + " "
                                                    }).join(" | ") : ""}>
                                                        {cutString(row?.ticketsBought ? row.ticketsBought.map((ticket, i) => {
                                                            return ticket.bookingQty + " x " + ticket.ticketType + " "
                                                        }).join(" | ") : "", 25, true)}
                                                    </p>
                                                </td> */}
                                                <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-500">
                                                    {ticketAmount(row)}
                                                    <p className="text-xs text-gray-400 font-normal text-wrap">{getPaymentStatus(row)}</p>
                                                </td>
                                                <td className="relative whitespace-nowrap py-4 pl-3 pr-4 text-right text-sm font-medium sm:pr-6">
                                                    {userReduxState.userData?.userType != "student" && (<SessionBookingPopover
                                                        bookingType={bookingType}
                                                        bookingDetails={row}
                                                        handleUpdate={() => {
                                                            getRecentBookings()
                                                        }}
                                                    />)}
                                                </td>
                                            </tr>
                                        )
                                    }) : listLoading === false && (
                                        <tr>
                                            <td colSpan={8} className="whitespace-nowrap py-4 pl-4 pr-3 text-sm font-medium text-gray-500 sm:pl-6 text-center">
                                                There is no booking
                                            </td>
                                        </tr>
                                    ))}
                                    {listLoading === true ? (
                                        <tr>
                                            <td colSpan={8} className="whitespace-nowrap py-4 pl-4 pr-3 text-sm font-medium text-gray-500 sm:pl-6 text-center">
                                                Loading...
                                            </td>
                                        </tr>
                                    ) : null}
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
                {showViewMore ? (<div className={"flex flex-row justify-center my-2"}>
                    <button
                        className={
                            "text-white text-sm cursor-pointer bg-blue-bz rounded-lg p-2 px-5"
                        }
                        onClick={() => {
                            setRecentBookingsPageNumber(recentBookingsPageNumber + 1);
                        }}
                    >
                        View More
                    </button>
                </div>) : ""}
            </div>
            <div className="overflow-x-auto hidden">
                <table className="min-w-full divide-y divide-gray-300">
                    <thead className="">
                        <tr className="text-center">
                            <th scope="col" className={classNames("py-3.5 pl-4 pr-3 text-center text-base font-extrabold text-gray-500 sm:pl-6 truncate", bookingType === "consumerBookings" ? "hidden" : "")}>
                                CUSTOMER
                            </th>
                            <th scope="col" className="px-3 py-3.5 text-left text-base font-extrabold text-gray-500 truncate">
                                BOOKING ID
                            </th>
                            <th scope="col" className="px-3 py-3.5 text-left text-base font-extrabold text-gray-500 truncate">
                                ACTIVITY BOOKED
                            </th>
                            <th scope="col" className="px-3 py-3.5 text-left text-base font-extrabold text-gray-500 truncate">
                                SEATS BOOKED
                            </th>
                            <th scope="col" className="px-3 py-3.5 text-left text-base font-extrabold text-gray-500 truncate">
                                AMOUNT PAID
                            </th>
                            <th scope="col" className="px-3 py-3.5 text-center text-base font-extrabold text-gray-500"></th>
                        </tr>
                    </thead>
                    <tbody className="divide-y-8 !border-y-0 divide-white ">
                        {listLoading ? (
                            <tr>
                                <td colSpan={6} className="bg-td-row hover:bg-td-row-h whitespace-nowrap py-4 pl-4 pr-3 text-sm font-medium text-gray-500 sm:pl-6 text-center rounded-2xl">
                                    Loading...
                                </td>
                            </tr>
                        ) : recentBookingsList.length ? recentBookingsList.map((row, i) => (
                            <tr key={i} className="bz-td-row">
                                <td className={classNames("bg-white whitespace-nowrap px-3 py-4 text-left text-sm font-bold rounded-l-2xl", bookingType === "consumerBookings" ? "hidden" : "")}>
                                    <div className="flex justify-center items-center min-w-4/5">
                                        <div className="flex-none">
                                            {row?.student_detail?.profilePic ? (<img
                                                className="size-8 rounded-full mr-3"
                                                src={row.student_detail.profilePic}
                                                alt={``}
                                            />) : (<img
                                                className="size-8 rounded-full mr-3"
                                                src={profile_img}
                                                alt={``}
                                            />)}
                                        </div>
                                        <div className="w-28">
                                            {/* <div>{cutString(row?.studentName, 10, true)}</div> */}
                                            <div>{cutString(row?.student_detail?.fullName, 10, true)}</div>
                                            <div className="text-indigo-bz">{cutString((row.student_detail?.countryCode ? row.student_detail.countryCode + "_" + row.student_detail.phoneNumber : "" + row?.student_detail?.username), 10, true)}</div>
                                        </div>
                                    </div>
                                </td>
                                <td className={classNames("bg-white whitespace-nowrap px-3 py-4 text-left text-sm font-bold", bookingType === "consumerBookings" ? "rounded-l-2xl" : "")}>
                                    {row.bookingId}
                                    <p className="text-xs text-gray-400 font-normal text-wrap"><span className={`${(row.status === "Cancelled") ? "text-bz-status-red" : "text-bz-status-green"}`}>{row.status}</span> | {moment(row.bookingDate).format("MMM D")}</p>
                                </td>
                                <td className="bg-white whitespace-nowrap px-3 py-4 text-left text-sm font-bold">
                                    {row.className}
                                    <p className="text-xs text-gray-400 font-normal text-wrap">{row.schedule_class_detail && row.schedule_class_detail.classDate ? moment(row.schedule_class_detail.classDate).format('MMM D, hh:mm A') : ""}</p>
                                </td>
                                <td className="bg-white whitespace-nowrap px-3 py-4 text-left text-sm font-bold">
                                    {row.bookingQty ? row.bookingQty : "1"}
                                    <p className="text-xs text-gray-400 font-normal text-wrap" title={row?.ticketsBought ? row.ticketsBought.map((ticket, i) => {
                                        return ticket.bookingQty + " x " + ticket.ticketType + " "
                                    }).join(" | ") : ""}>
                                        {cutString(row?.ticketsBought ? row.ticketsBought.map((ticket, i) => {
                                            return ticket.bookingQty + " x " + ticket.ticketType + " "
                                        }).join(" | ") : "", 25, true)}
                                    </p>
                                </td>
                                <td className="bg-white whitespace-nowrap px-3 py-4 text-left text-sm font-bold">
                                    {ticketAmount(row)}
                                    <p className="text-xs text-gray-400 font-normal text-wrap">{getPaymentStatus(row)}</p>
                                </td>
                                <td className="bg-white whitespace-nowrap px-3 py-4 text-center text-sm font-bold rounded-r-2xl">
                                    {userReduxState.userData?.userType != "student" && (<SessionBookingPopover
                                        bookingType={bookingType}
                                        bookingDetails={row}
                                        handleUpdate={() => {
                                            getRecentBookings()
                                        }}
                                    />)}
                                </td>
                            </tr>
                        )) : (
                            <tr>
                                <td colSpan={6} className="bg-td-row hover:bg-td-row-h whitespace-nowrap py-4 pl-4 pr-3 text-sm font-medium text-gray-500 sm:pl-6 text-center rounded-2xl">
                                    There is no {bookingFilter !== "all" ? bookingFilter + " " : ""}bookings
                                </td>
                            </tr>
                        )}

                    </tbody>
                </table>
            </div>
            {false && showViewMore ? (<div className={"flex flex-row justify-center my-4"}>
                <button
                    className={
                        "text-white text-sm cursor-pointer bg-blue-bz rounded-lg p-2 px-5"
                    }
                    onClick={() => {
                        setRecentBookingsPageNumber(recentBookingsPageNumber + 1);
                    }}
                >
                    View More
                </button>
            </div>) : ""}
        </div>
    );
}
